module.exports = __webpack_public_path__ + "static/media/QWitch.82e18cb4.png";